export enum ActionType {
  SetPageName = '[App Page] SetPageName',
  SetNavigationOpenState = '[Navigation module] SetNavigationOpenState'
}
